module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"View review details","product_button_label":"View all reviews for this product"}}')
  delete Component.options._Ctor
}
